// modules/StoreLocator/panel.ts
export function hidePanel() {
    const panel = document.getElementById("store-locator-panel");
    const panelContent = document.getElementById("panel-content") as HTMLElement;
    const closeBtn = panel?.querySelector(".panel__close");
    if (!panel || !closeBtn) return;

    const closePanel = () => {
        panel.classList.remove("visible");
    };

    closeBtn.addEventListener("click", (event) => {
        event.stopPropagation();
        panelContent.innerHTML = '';
        closePanel();
    });

    // document.addEventListener("click", (event) => {
    //     if (!panel.contains(event.target as Node)) {
    //         closePanel();
    //     }
    // });
}
